var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card",style:(_vm.wh)},[_c('a',{staticClass:"image-card-mask",style:(_vm.mask),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"image-card-title"},[_vm._v(_vm._s(this.media.filename))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }